module.exports = __webpack_public_path__ + "static/media/tangermed.b10a2f49.jpeg";